export default "__VITE_ASSET__dsCKMQcs__"